import React, { memo, useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// antd component
import { Form, message, Button, Upload } from "antd";

// components
import PreviewMedia from "components/Forms/Fields/PreviewMedia";

// utils
import api from "utils/api";
import { normFile } from "utils/uploadHelper";
import _local from 'utils/localStorageUtils';

function MediaFormPreview({
  formData,
  isEdit,
  currentStep,
  role,
  // actions
  nextStep,
  prevStep,
  goToStep,
  result,
  // default
  className,
}) {
  const childClassName = classNames("form-absence", className);
  const { t } = useTranslation();

  const localUser = _local.getLocalUser();

  const [isDisabled, setIsDisabled] = useState(false);
  const [AbsFormMediaPreview] = Form.useForm();

  const [mediaFiles, setMediaFiles] = useState([]);

  /*
   * Check current form data from parent
   * Set old data to the form
   */
  useEffect(() => {
    if (formData?.media?.length > 0) {
      AbsFormMediaPreview.setFieldsValue(formData);
      setMediaFiles(formData?.media || []);
      setIsDisabled(false);
    } else {
      // go to preview file
      !!goToStep && goToStep(currentStep - 1);
    }
  }, [formData]);

  const onFinish = values => {
    if (values?.media?.length > 0) {
      result(values);
    } else {
      setMediaFiles([]);
      result({ ...formData, media: [] });
    }

    AbsFormMediaPreview.resetFields();
    setMediaFiles([]);

    if (isEdit && localUser?.role == 'parent') {
      !!goToStep && goToStep(4);
    } else {
      !!nextStep && nextStep();
     // !!goToStep && goToStep(6);
    }
  };

  const fileOnRemove = useCallback(
    async file => {
      try {
        if (typeof file === "string") {
          await api.media.delete(file);
        } else if (formData && formData?.media?.length > 0) {
          formData?.media?.map(async fileUrl => {
            if (typeof fileUrl === "string") {
              await api.media.delete(fileUrl);
            }
          });
        }
      } catch (err) {
        console.error(err);
      }

      AbsFormMediaPreview.resetFields();
      setMediaFiles([]);
      result({
        ...formData,
        media: [],
      });

      !!prevStep && prevStep();
    },
    [formData, formData?.media],
  );

  const customItemRender = (originNode, file) => {
    return <PreviewMedia file={file} remove={fileOnRemove} />;
  };

  const goBack = () => {
    let toStep = currentStep - 2;
    //prevStep !== undefined && prevStep();
    AbsFormMediaPreview.resetFields();
    !!goToStep && goToStep(toStep);
  };

  return (
    <div className={childClassName}>
      <Form
        form={AbsFormMediaPreview}
        className="form-absence__form form-proof__form"
        name="form_absence_media_upload"
        initialValues={{}}
        onFinish={onFinish}
        onValuesChange={() => setIsDisabled(false)}
      >
        <div className="form-proof">
          <Form.Item
            name="media"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            noStyle
            normalize={(value, prevValue, prevValues) => {
              if (value?.length > 1) {
                message.error("Uniquement 1 fichier");
                return false;
              }
            }}
          >
            <Upload
              multiple={false}
              maxCount={1}
              fileList={mediaFiles}
              onRemove={fileOnRemove}
              itemRender={customItemRender}
            />
          </Form.Item>
        </div>

        <div className="absence-actions-wrapper">
          {/*  {
            (
              (!isEdit?._id && role == "parent") ||
              (!isEdit?._id && role == "teacher")
            ) && (
            <Button className="btn-previous" onClick={goBack}>
              {t("common.previous")}
            </Button>
          )} */}

          <Button
            className="next-btn"
            form={`form_absence_media_upload`}
            htmlType="submit"
            disabled={isDisabled}
          >
            {t("common.next")}
          </Button>
        </div>
      </Form>
    </div>
  );
}

MediaFormPreview.defaultProps = {};
MediaFormPreview.propTypes = {
  result: PropTypes.func.isRequired,
  nextStep: PropTypes.func.isRequired,
  prevStep: PropTypes.func.isRequired,
  goToStep: PropTypes.func.isRequired,
};

export default memo(MediaFormPreview);
